import { useTranslation } from 'react-i18next'

import { Add } from '@mui/icons-material'
import { Box, Button, Chip, Fab, Grid, Tooltip } from '@mui/material'

import { useField, useFormikContext } from 'formik'

import PageHeading from 'components/atoms/PageHeading'

import { IParticipant } from 'types'

import SelectField from 'components/atoms/fields/SelectField'
import { useGET_usersSelectQuery } from 'redux/api/usersApi'
import { FaTrashAlt } from 'react-icons/fa'
import { cloneDeep } from 'lodash'

const ParticipantList = ({ fieldProps, disabled, isProtocol }) => {
  const { t } = useTranslation()
  const [field] = useField<IParticipant[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        participant: { id: '', title: '' },
        role: '',
        mail: '',
        phone: '',
        has_attended: true,
      },
    ])
  }

  const handleRemoveEntity = (index) => {
    const entities = cloneDeep(field.value)
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }

  return (
    <>
      <div style={{ marginTop: '40px' }}>
        <PageHeading title={isProtocol ? t('meetings.has-attended') : t('meetings.participants')}/>
      </div>
      
      {field?.value?.length > 0 ? (
          field?.value.map((value: IParticipant, index: number) => (

          <Box 
              className="transparent-background"
              key={`participant_${index}`}
          >
            <Box 
              className="transparent-background"
              my={4}
              sx={{
                display: 'flex',
                width: '400px',
                maxWidth: '100%',
              }}
            >
              <SelectField
                  fieldProps={{
                    label: t('meetings.participant'),
                    name: `${fieldProps.name}[${index}]['participant']`,
                    required: true,
                  }}
                  apiCall={useGET_usersSelectQuery}
                  disabled={disabled}
               />
              {!disabled &&
                  <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                    <Button
                      onClick={() => { 
                        handleRemoveEntity(index) 
                      } }
                      aria-label='delete'
                      size='small'
                      color='error'
                      variant='outlined'
                      sx={{
                        margin: '0',
                        marginLeft: '10px',
                        boxShadow: 'none',
                        padding: '0.5rem 0.1rem',
                        minWidth: '2.5rem !important',
                        maxWidth: '2.5rem !important',
                      }}
                    >
                      <FaTrashAlt style={{ fontSize: '1.2rem' }} />
                    </Button>
                  </Tooltip>
              }
            </Box>
          </Box>
          ))
        ) : (
          <></>
        )}

        {!disabled &&
          <Tooltip title={`${t('common.add')}`} arrow placement='top'>
            <Fab
              variant='extended'
              aria-label='add'
              size='small'
              onClick={handleAddEntity}
              color='success'
              sx={{ margin: '1rem 0 0.5rem auto', boxShadow: 'none' }}
            >
              <Add style={{ fontSize: '1.8rem' }} /> {t('common.add-participant')}
            </Fab>
          </Tooltip>
        }
    </>
  )
}

export default ParticipantList
